
import type { TIconKey } from "@/ui/components/primitives/Icon";
import type { DefinedDefaults } from "@/ui/lib/types";
import { TAlertProps } from "../Alert";

/*-------------------------------------
|  Constants
-------------------------------------*/

export const DISMISSABLE_ALERT_VARIANT_CLASS_MAP = {
  default: "border-muted bg-surface-subtle text-foreground",
  destructive: "border-functional-destructive bg-surface-subtle text-functional-destructive",
} as const;

/*-------------------------------------
|  Types
-------------------------------------*/

export type TDismissableAlertVariant =
  keyof typeof DISMISSABLE_ALERT_VARIANT_CLASS_MAP;

export type TDismissableAlertProps = Omit<TAlertProps, "variant"> & {
  asset?: TIconKey;
  variant?: TDismissableAlertVariant;
};

type TDismissableAlertDefaultProps = DefinedDefaults<
  TDismissableAlertProps,
  "variant"
>;

/*-------------------------------------
|  Defaults
-------------------------------------*/

export const DISMISSABLE_ALERT_DEFAULTS = {
  variant: "default",
} satisfies TDismissableAlertDefaultProps;
